import React, {useState} from "react";
import styles from "./AddToWishlistButton.module.scss";
import {useTranslation} from "react-i18next";
import WishlistHeart from "../WishlistHeart";
import {useAppDispatch, useWishlistSelector} from "../../../store";
import {toggleAddItem} from "../../../store/slices/wishlishSlice";

type AddToWishlistButtonPropsType = {
  itemId: number;
  animated?: boolean;
  filledColor?: "blue" | "green" | "darkgrey";
  outlineColor?: "blue" | "green" | "darkgrey";
  size?: "big" | "small";
  showAsText?: boolean;
  customClass?: string;
};

const AddToWishlistButton: React.FC<AddToWishlistButtonPropsType> = ({
  itemId,
  animated = false,
  filledColor = "green",
  outlineColor = "darkgrey",
  size = "big",
  showAsText,
  customClass = "",
}) => {
  const {wishlist} = useWishlistSelector();
  const dispatch = useAppDispatch();
  const isAlreadyAdded = !!wishlist?.items.some(({item}) => item.itemId === itemId);
  const {t} = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [toggleAnimate, setToggleAnimated] = useState(false);
  const label = isAlreadyAdded ? t("wishlist.removeFromList") : t("wishlist.addToWishlist");

  const handleItem = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();

    if (isLoading) {
      return;
    }

    setToggleAnimated(true);
    setTimeout(() => {
      setToggleAnimated(false);
    }, 400);
    setIsLoading(true);

    void dispatch(toggleAddItem(itemId)).finally(() => {
      setIsLoading(false);
    });
  };

  return (
    <button
      className={`${
        !animated ? styles.wrapper : `${styles.wrapperAnimated} ${toggleAnimate ? `${styles.reaction}` : ""}`
      } ${customClass}`}
      onClick={handleItem}
      title={label}
      aria-label={label}
    >
      {isLoading && !animated && <div className={styles.loaderWrapper} />}
      {showAsText && !isAlreadyAdded ? (
        <span>{t("wishlist.addProductToList")}</span>
      ) : (
        (!isLoading || animated) && (
          <WishlistHeart filled={isAlreadyAdded} color={filledColor} outlineColor={outlineColor} size={size} />
        )
      )}
    </button>
  );
};

export default AddToWishlistButton;
